import {
  Component,
  computed,
  Input,
  input,
  output,
  signal,
} from '@angular/core';
import { ButtonModule } from '@app/components/atoms/button/button.module';

@Component({
  selector: 'app-action-item',
  standalone: true,
  templateUrl: './action-item.component.html',
  styleUrls: ['./action-item.component.scss'],
  imports: [ButtonModule],
})
export class ActionItemComponent {
  title = input.required<string>();
  description = input.required<string>();
  showDivider = input<boolean>(true);
  showDescription = input<boolean>(true);
  enableEdit = input<boolean>(false);
  enableDelete = input<boolean>(false);
  enableAdd = input<boolean>(false);
  edit = output<void>();
  delete = output<void>();
  add = output<void>();
  externalEditing = input<boolean | null>(null);
  requestEdit = output<void>();
  isEditing = signal(false);
  @Input() type: string = 'item';

  editingState = computed(() => {
    const controlled = this.externalEditing();
    return controlled === null ? this.isEditing() : controlled;
  });

  toggleEdit() {
    this.requestEdit.emit();

    if (this.externalEditing() === null) {
      this.isEditing.update(prev => !prev);
    }
    if (this.editingState()) this.edit.emit();
  }

  onDelete() {
    this.delete.emit();
  }
  onAdd() {
    this.add.emit();
  }
}
